import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { paymentCycleConfig } from './PaymentCycle.name';

/** 支払サイクルのENUM */
enum PaymentCycle {
  /** 毎月 */
  everyMonth = '1',
  /** 2ヶ月毎 */
  everyTwoMonths = '2',
  /** 3ヶ月毎 */
  everyThreeMonths = '3',
  /** 4ヶ月毎 */
  everyFourMonths = '4',
  /** 半年毎 */
  semiannually = '5',
  /** 1年毎 */
  annually = '6',
  /** 未設定 */
  unset = '9',
}

const paymentCycleMap = new Map([
  ['1', PaymentCycle.everyMonth],
  ['2', PaymentCycle.everyTwoMonths],
  ['3', PaymentCycle.everyThreeMonths],
  ['4', PaymentCycle.everyFourMonths],
  ['5', PaymentCycle.semiannually],
  ['6', PaymentCycle.annually],
  ['9', PaymentCycle.unset],
]);

function rawValueToPaymentCycle(rawValue: string) {
  return rawValueToEnumWithDefault(paymentCycleMap, PaymentCycle.unset)(rawValue);
}

function paymentCycleToServer(value: PaymentCycle) {
  switch (value) {
    case PaymentCycle.everyMonth:
      return 'EVERY_MONTHLY';
    case PaymentCycle.everyTwoMonths:
      return 'EVERY_TWO_MONTHS';
    case PaymentCycle.everyThreeMonths:
      return 'EVERY_THREE_MONTHS';
    case PaymentCycle.everyFourMonths:
      return 'EVERY_FOUR_MONTHS';
    case PaymentCycle.semiannually:
      return 'SEMIANNUALLY';
    case PaymentCycle.annually:
      return 'ANNUALLY';
    case PaymentCycle.unset:
      return 'UNSET';
  }
}

const paymentCycleToDisplay = enumToNameWithDefault(PaymentCycle, paymentCycleConfig);

const paymentCycleToDisplayWithPrefix = enumToNameWithDefault(PaymentCycle, paymentCycleConfig, true);

export {
  PaymentCycle,
  paymentCycleToDisplay,
  paymentCycleToDisplayWithPrefix,
  paymentCycleToServer,
  rawValueToPaymentCycle,
};
